module.exports = "<template> </template>\n";